import { Card, CardContent } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { AlertTriangle } from "lucide-react"

interface ErrorStateProps {
  title: string
  description: string
  onRetry?: () => void
  retryLabel?: string
}

export function ErrorState({
  title,
  description,
  onRetry,
  retryLabel = "Retry",
}: ErrorStateProps) {
  return (
    <Card className="bg-card border-destructive/20 rounded-2xl">
      <CardContent className="p-12 flex flex-col items-center justify-center text-center space-y-6">
        <div className="w-20 h-20 rounded-2xl bg-destructive/20 flex items-center justify-center">
          <AlertTriangle className="w-10 h-10 text-destructive" />
        </div>
        <div className="space-y-2">
          <h3 className="text-2xl font-bold text-foreground">{title}</h3>
          <p className="text-muted-foreground max-w-md">{description}</p>
        </div>
        {onRetry && (
          <Button 
            onClick={onRetry}
            variant="outline"
            className="border-border hover:bg-card"
          >
            {retryLabel}
          </Button>
        )}
      </CardContent>
    </Card>
  )
}
